const STORAGE_KEY = 'orchestratorTrackers';

export const FEAR_TRACKER_ID = 'fear';

export function buildFearTracker() {
  return {
    id: FEAR_TRACKER_ID,
    name: '',
    size: 12,
    value: 0,
    visible: true,
    locked: true,
  };
}

export function loadTrackers() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveTrackers(trackers) {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trackers));
  } catch {
    // ignore
  }
}

export function getInitialTrackers(ttrpgSystem) {
  if (ttrpgSystem !== 'daggerheart') return [];
  const stored = loadTrackers();
  if (stored && stored.length > 0) {
    const hasFear = stored.some((t) => t.id === FEAR_TRACKER_ID);
    if (hasFear) return stored;
    return [buildFearTracker(), ...stored];
  }
  return [buildFearTracker()];
}
